// frontend/src/components/common/Input.jsx
import { useId } from "react";
import Field from "./Field";
import { describedBy } from "./fieldUtils";
import "./ui.css";

/**
 * Text input with label / hint / error. Remaining props go to <input>.
 * React 19: `ref` is a regular prop and is forwarded to the <input>.
 * size: sm | md | lg; leading / trailing: adornment nodes.
 */
export default function Input({ id, label, hint, error, leading, trailing, size = "md", className = "", fieldClassName = "", ref, required, ...props }) {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <Field id={inputId} label={label} hint={hint} error={error} required={required} className={fieldClassName}>
      <div className={`control control--${size}${leading ? " has-leading" : ""}${trailing ? " has-trailing" : ""}`}>
        {leading && <span className="control__adorn control__adorn--lead">{leading}</span>}
        <input
          ref={ref}
          id={inputId}
          className={`control__input ${className}`.trim()}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(inputId, hint, error)}
          required={required}
          {...props}
        />
        {trailing && <span className="control__adorn control__adorn--trail">{trailing}</span>}
      </div>
    </Field>
  );
}
